import { Injectable, Signal } from '@angular/core';
import { IAccountData, IAccountModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { AccountActions, AccountSelectors, IAccountState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class AccountStore extends StateAccessService<IAccountState> {
  readonly state$: Observable<IAccountState>;

  readonly data$$: Signal<IAccountData>;
  readonly model$$: Signal<IAccountModel>;

  constructor() {
    super();

    this.state$ = this.stateFacade.select$(AccountSelectors.accountState);

    this.model$$ = this.stateFacade.selectSignal$(AccountSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(AccountSelectors.data);
  }

  dispatchAccountReset() {
    this.stateFacade.dispatch(AccountActions.reset());
  }
  dispatchAccountLoad() {
    this.stateFacade.dispatch(AccountActions.load());
  }
  dispatchAccountLoadSuccess({ model, data }: { model: IAccountModel; data: IAccountData }) {
    this.stateFacade.dispatch(AccountActions.loadSuccess({ model, data }));
  }
}
